import { render, staticRenderFns } from "./AutoSuggestExperience.vue?vue&type=template&id=57b65a1a&"
import script from "./AutoSuggestExperience.vue?vue&type=script&lang=js&"
export * from "./AutoSuggestExperience.vue?vue&type=script&lang=js&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports